
const ManageUsers = ({ width = 23, height = 24 }) => (
	<svg width={width} height={height} viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6.07692 21.5H1V18.9844C1.01347 17.7062 1.35365 16.4522 1.98877 15.3395C2.62389 14.2269 3.53322 13.2919 4.63182 12.622C5.73042 11.952 6.98246 11.5689 8.27097 11.5085C9.55949 11.448 10.8424 11.7122 12 12.2763M12 5C12 6.933 10.433 8.5 8.5 8.5C6.567 8.5 5 6.933 5 5C5 3.067 6.567 1.5 8.5 1.5C10.433 1.5 12 3.067 12 5ZM22 14.4591L14.4254 22.0336L11 22.5L11.4825 19.0746L19.0409 11.5L22 14.4591Z" stroke="currentColor" strokeWidth="1.71429" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export default ManageUsers;